export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'km', name: 'ខ្មែរ', flag: '🇰🇭' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
] as const

export const DEFAULT_LANGUAGE = 'en'

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code']
